var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.815,
    height: 12.088,
    viewBox: "0 0 13.815 12.088",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-gift",
    "data-name": "Icon awesome-gift",
    d: "M.863,13.475a.863.863,0,0,0,.863.863H6.044V10.021H.863Zm6.908.863h4.317a.863.863,0,0,0,.863-.863V10.021H7.771ZM12.952,5.7H11.816a2.353,2.353,0,0,0,.273-1.079A2.378,2.378,0,0,0,9.714,2.25c-1.122,0-1.848.575-2.779,1.843C6,2.825,5.278,2.25,4.155,2.25A2.378,2.378,0,0,0,1.781,4.625,2.32,2.32,0,0,0,2.053,5.7H.863A.863.863,0,0,0,0,6.567V8.726a.433.433,0,0,0,.432.432H13.384a.433.433,0,0,0,.432-.432V6.567A.863.863,0,0,0,12.952,5.7Zm-8.8,0a1.079,1.079,0,1,1,0-2.159c.537,0,.934.089,2.323,2.159Zm5.561,0H7.391C8.778,3.64,9.163,3.545,9.714,3.545a1.079,1.079,0,1,1,0,2.159Z",
    transform: "translate(0 -2.25)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.8fb6717a93a6cc47252e327a38ed4503.svg";
export { ForwardRef as ReactComponent };